import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  Container,
  Flex,
  Heading,
  Stack,
  VStack,
  HStack,
  Text,
  Avatar,
  IconButton,
  Button,
  Image,
  CircularProgress,
} from "@chakra-ui/react";
import { useMemo } from "react";

import { ChevronLeftIcon } from "@chakra-ui/icons";
// import { CgDatabase } from "react-icons/cg";
import ArrowForwardIosRoundedIcon from "@material-ui/icons/ArrowForwardIosRounded";

// import User from "assets/profile.svg";
// import Bank from "assets/svg/icons-new/banks.svg";
// import Edit from "assets/svg/icons-new/edit.svg";
// import Support from "assets/svg/icons-new/support.svg";
// import Refer from "assets/svg/icons-new/refer.svg";
// import VerificationIcon from "../../../assets/svg/verification.svg";
import CompletedTradesIcon from "assets/svg/completed-trades.svg";

//assets
// import BTC from "assets/svg/btcw.svg";
// import ETH from "assets/svg/ethw.svg";

// components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";
// import ReferrerList from "components/ReferrerList/ReferrerList";

// import AccountLink from "components/AccountLink/AccountLink";
//   import VerificationCard from "components/VerificationCard/VerificationCard";
import useCoinInfo from "hooks/useCoinInfo";
// import { useIntercom } from "react-use-intercom";
// import ProfileShortInfo from "components/ProfileShortInfo/ProfileShortInfo";
import toPrecision from "util/toPrecision";
import { useGetReferralEarningsQuery } from "services/arbitraryApi";
import AccountSidebar from "components/AccountSidebar/AccountSidebar";

// const isEmptyString = (val) => val === "" || val === undefined || val === null;
import { useParams, useHistory } from "react-router-dom";
import capitalize from "lodash/capitalize";

function CommissionButton({ amount, coin }) {
  const { image } = useCoinInfo(coin);
  const history = useHistory();

  return (
    <Button
      variant="ghost"
      bg="white"
      minH="fit-content"
      minW="fit-content"
      w="100%"
      p="14px 20px"
      h="fit-content"
      _focus={{
        shadow: "0 0 0 3px var(--focusColor)",
        borderColor: "var(--primary)",
      }}
      _hover={{ bg: "white" }}
      borderRadius="16px"
      border="1px solid #EFF0F6"
      shadow="0px 0px 5px rgba(0, 0, 0, 0.05)"
      onClick={() => history.push(`/dashboard/wallet/${coin}`)}
    >
      <HStack w="100%">
        <Image
          objectFit="cover"
          alt=""
          boxSize="48px"
          src={image}
          borderRadius="50%"
          overflow="hidden"
        />
        <Text fontWeight="600" color="#14142B">
          {toPrecision(amount, coin, true, 8, true)}
        </Text>
      </HStack>
    </Button>
  );
}

const AccountReferralList = (props) => {
  // const { boot } = useIntercom();
  const userData = props.userData;

  const { listType, id } = useParams();

  const history = useHistory();

  const { data, isLoading } = useGetReferralEarningsQuery(id);

  // const
  const refereeName = useMemo(() => {
    const referee = props?.location?.state;
    return referee?.fullName ?? `${referee?.firstName} ${referee?.lastName}`;
  }, [props]);

  console.log("EARNING", data, id);

  // console.log("ACCOUNT VERIFICAATION PAGE PROPS", props);

  return (
    <Box>
      <Sidemenu currentPage="Account" logoutUser={props.logout} />
      <Header />
      <Box as="section">
        <div className="account-container">
          <Flex className="flex">
            <Box flex=".8" borderRight="1px solid #D9DBE9" position="sticky">
              <Container maxW="calc(100% - 2em)" ml="10px">
                <Stack mb="48px">
                  <Heading>Account</Heading>
                  <Breadcrumb
                    className="animate__animated animate__fadeInDown"
                    separator={
                      <ArrowForwardIosRoundedIcon
                        style={{ fontSize: ".8em", color: "#6E7191" }}
                      />
                    }
                  >
                    <BreadcrumbItem>
                      <BreadcrumbLink to={`/dashboard/account`}>
                        Account
                      </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbItem>
                      <BreadcrumbLink to={`/dashboard/account/refer`}>
                        Refer a friend
                      </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbItem>
                      <BreadcrumbLink
                        to={`/dashboard/account/refer/${listType}`}
                      >
                        {capitalize(listType)}
                      </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbItem isCurrentPage>
                      <BreadcrumbLink isCurrentPage>Details</BreadcrumbLink>
                    </BreadcrumbItem>
                  </Breadcrumb>
                </Stack>

                <AccountSidebar
                  pos="sticky"
                  top="0"
                  current="refer"
                  userData={userData}
                  logout={props.logout}
                />
              </Container>
            </Box>

            <Box flex="1">
              <Container
                maxW="lg"
                // ml={{ lg: "60px" }}
              >
                <VStack w="100%">
                  <Stack gridGap="20px" padding={"1rem"} w="100%">
                    <HStack w="100%">
                      <IconButton
                        variant="ghost"
                        aria-label="back"
                        maxW="fit-content"
                        icon={<Box fontSize="26px" as={ChevronLeftIcon} />}
                        _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                        // _hover={{shadow: "0 0 0 3px var(--focusColor)" }}
                        onClick={() =>
                          history.push(`/dashboard/account/refer/${listType}`)
                        }
                      />
                      <Heading as="h4" fontSize="2xl">
                        Referee details
                      </Heading>
                    </HStack>
                    <VStack w="100%">
                      <VStack w="100%">
                        <Avatar name={refereeName} size="xl" />
                        <Text fontSize="md" color="#14142B">
                          {refereeName}
                        </Text>

                        {!isLoading && (
                          <HStack
                            variant="ghost"
                            bg="#FCFCFC"
                            w="100%"
                            p="12px"
                            borderRadius="16px"
                            border="1px solid #EFF0F6"
                            mt="20px !important"
                          >
                            <Image
                              alt=""
                              boxSize="56px"
                              src={CompletedTradesIcon}
                            />
                            <Stack ml="14px !important">
                              <Text
                                fontSize="18px"
                                color="#14142B"
                                fontWeight="600"
                              >
                                {data?.totalCount ?? 0}
                              </Text>
                              <Text
                                mt="0 !important"
                                fontSize="sm"
                                color="#6E7191"
                                fontWeight="600"
                              >
                                Completed trades
                              </Text>
                            </Stack>
                          </HStack>
                        )}
                      </VStack>

                      {/* {data?.earnings?.length < 1 && !isLoading && (
                        <VStack py="32px">
                          <Box as={CgDatabase} fontSize="48px" color="grey" />
                          <Text color="grey">No Data</Text>
                        </VStack>
                      )} */}

                      {isLoading && (
                        <VStack py="32px">
                          <CircularProgress
                            ml="20px !important"
                            isIndeterminate
                            color="var(--primary)"
                            size="20px"
                          />
                        </VStack>
                      )}

                      {!isLoading && data?.totalCount > 0 && (
                        <VStack
                          alignItems="flex-start"
                          w="100%"
                          mt="24px !important"
                        >
                          <Text fontSize="lg" fontWeight="600" color="#14142B">
                            Commission earned
                          </Text>

                          {(data?.earnings ?? []).map((item, i) => (
                            <CommissionButton
                              key={`commission-button-${i}`}
                              amount={item?.signedValue?.$numberDecimal}
                              coin={item?.unit}
                            />
                          ))}
                        </VStack>
                      )}
                    </VStack>
                  </Stack>
                </VStack>
              </Container>
            </Box>
          </Flex>
        </div>
      </Box>
    </Box>
  );
};

export default AccountReferralList;
